import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-logo-slogan',
  template: `
    <p class="app-logo-slogan">
      {{ slogan }}
    </p>
  `,
  styles: [`
    .app-logo-slogan {
        padding: 10px 0;
        text-align: center;
    }
  `]
})
export class LogoSloganComponent {
  @Input() slogan: string = 'Food Auditor and Safety Manager';
}
